module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-fe621e35f5dc0de35677cdec0323270a.webp";